<script>
  import unionby from 'lodash/unionby';
  import { onMount } from 'svelte';
  import { selectData, getInsetData } from './helper.js';
  import SpectrumViz from './SpectrumViz.svelte';
  export let index = 1;
  export let type = 'bands';
  export let allData = {};
  export let googleDoc = {};
  export let showButtons = true;

  let steps =
    type == 'bands'
      ? ['Radio spectrum', 'Bands']
      : ['govt', 'Crowded', 'Size of bands', 'Auctions'];
  //bindings

  let scrollY = 0;
  let data = [];
  $: data = selectData(allData, type, index);

  let insetData = [];
  let initialized = false;
  let mainWidth = 100;
  let mainHeight = 100;

  let insetWidth = 100;
  let insetHeight = 100;

  let domain = [20, 300000000];
  let insetDomain = [0, 1];

  $: {
    if (type == 'bands') {
      if (index == 0) {
        domain = [1, 300000000];
        insetDomain = [10e2, 10e25];
      } else if (index == 1) {
        domain = [20, 100000000];
        insetDomain = [20, 300000000];
      } else if (index == 2) {
        domain = [20, 100000000];
        insetDomain = [20, 300000000];
      }
    } else {
      if (index <= 2) {
        domain = [20, 100000000];
        insetDomain = [20, 300000000];
      } else if (index >= 3) {
        domain = [20, 6000000];
        insetDomain = [20, 300000000];
      }
    }
  }

  onMount(() => {
    setTimeout(function() {
      initialized = true;
    }, 100);
  });
</script>

<style type="text/scss">.spectrum {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  padding: 20px 0;
  min-width: 100px;
  text-align: right; }
  @media only screen and (min-width: 860px) {
    .spectrum {
      width: calc(50% + 60px);
      max-width: 50%;
      left: 0;
      position: absolute; } }
  .spectrum-viz {
    height: 100%;
    width: 100%;
    max-width: 600px;
    position: relative;
    display: inline-block; }
</style>

{#if showButtons}
  {#each steps as step, i}
    <div
      class="button"
      on:click={() => {
        index = i;
      }}
      style="top: {(i + 2) * 50}px;">
      {step}
    </div>
  {/each}
{/if}

<svelte:window bind:scrollY />

<div class="spectrum">
  <div
    class="spectrum-viz"
    bind:offsetHeight={mainHeight}
    bind:offsetWidth={mainWidth}>
    {#if mainWidth > 100}
      <SpectrumViz
        {type}
        {index}
        {domain}
        height={mainHeight}
        width={mainWidth}
        {data}
        {initialized}
        totalIndex={googleDoc.scrolltext.length}
        annotations={googleDoc.annotations} />
    {/if}
  </div>
</div>
